// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-role-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.no-role-card {
  background: white;
  border-radius: 16px;
  padding: 48px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.no-role-icon {
  font-size: 64px;
  margin-bottom: 24px;
}

.no-role-card h1 {
  color: #333;
  margin-bottom: 24px;
  font-size: 28px;
}

.no-role-message {
  color: #555;
  font-size: 16px;
  margin-bottom: 12px;
  line-height: 1.6;
}

.no-role-instruction {
  color: #dc3545;
  font-size: 16px;
  font-weight: 500;
  margin: 24px 0;
  padding: 16px;
  background: #fff3f3;
  border-radius: 8px;
  border: 1px solid #f5c6cb;
}

.no-role-info {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin: 24px 0;
  text-align: left;
}

.no-role-info p {
  margin: 8px 0;
  color: #666;
}

.logout-btn {
  margin-top: 16px;
  padding: 12px 32px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/NoRole.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".no-role-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.no-role-card {\n  background: white;\n  border-radius: 16px;\n  padding: 48px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.no-role-icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n}\n\n.no-role-card h1 {\n  color: #333;\n  margin-bottom: 24px;\n  font-size: 28px;\n}\n\n.no-role-message {\n  color: #555;\n  font-size: 16px;\n  margin-bottom: 12px;\n  line-height: 1.6;\n}\n\n.no-role-instruction {\n  color: #dc3545;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 24px 0;\n  padding: 16px;\n  background: #fff3f3;\n  border-radius: 8px;\n  border: 1px solid #f5c6cb;\n}\n\n.no-role-info {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 24px 0;\n  text-align: left;\n}\n\n.no-role-info p {\n  margin: 8px 0;\n  color: #666;\n}\n\n.logout-btn {\n  margin-top: 16px;\n  padding: 12px 32px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
